import { initWidget } from './widget';
import endpoints from './widget/define/endpoints';

import SearchForm from './widget/component/SearchForm/SearchForm';
import AddToWishList from './widget/component/AddToWishList';
import SmartSearchForm from './widget/component/SearchForm/SmartSearchForm';
import SmartSearchTermsAutocomplete from './widget/component/SearchForm/SmartSearchTermsAutocomplete';

const initSpecificPageWidgets = () => {
    const props = {
        endpoints,
    };

    initWidget('search-form', SearchForm, props);
    initWidget('smart-search-form', SmartSearchForm, props);
    initWidget('smart-search-terms-autocomplete', SmartSearchTermsAutocomplete, props);
    initWidget('add-to-wish-list', AddToWishList, props);
};

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSpecificPageWidgets.bind(this));
} else {
    initSpecificPageWidgets();
}